import { filter, bufferTime } from 'rxjs/operators';
declare const imagesLoaded: any;

import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  ElementRef,
  EventEmitter,
  Inject
} from '@angular/core';

export interface IMasonryOptions {
  itemSelector?: string;
  columnWidth?: number | string;
  gutter?: number | string;
  percentPosition?: boolean;
  stamp?: string;
  fitWidth?: boolean;
  originLeft?: boolean;
  originTop?: boolean;
  containerStyle?: string;
  transitionDuration?: string;
  resize?: boolean;
  initLayout?: boolean;
}

import { Observable, Observer } from 'rxjs/Rx';

@Component({
  selector: '[masonry]',
  template: '<ng-content></ng-content>',
})
export class MasonryComponent implements OnInit {
  public _msnry: any;

  @Input() public options: IMasonryOptions;
  @Input() public useImagesLoaded: boolean = false;

  @Output() layoutComplete: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() removeComplete: EventEmitter<any[]> = new EventEmitter<any[]>();

  masonry;
  isBrowser;
  elementsToAdd$: Observable<HTMLElement>;
  elementsToAddObserver: Observer<HTMLElement>;
  elementsSubscriber;

  constructor(
    public _element: ElementRef,
    @Inject('isBrowser') isBrowser: boolean
  ) {
    if (isBrowser) {
      this.masonry = require('masonry-layout');
    }

    this.isBrowser = isBrowser;

    this.elementsToAdd$ = new Observable((observer) => {
      this.elementsToAddObserver = observer;
    });
  }

  ngOnInit() {
    if (!this.isBrowser) {
      return;
    }
    if (!this.options) {
      this.options = {};
    }

    if (!this.options.itemSelector) {
      this.options.itemSelector = '[masonry-brick], masonry-brick';
    }

    if (this._element.nativeElement.tagName === 'MASONRY') {
      this._element.nativeElement.style.display = 'block';
    }

    this._msnry = new this.masonry(this._element.nativeElement, this.options);

    this._msnry.on('layoutComplete', (items: any) => {
      this.layoutComplete.emit(items);
    });
    this._msnry.on('removeComplete', (items: any) => {
      this.removeComplete.emit(items);
    });

    this.elementsSubscriber = this.elementsToAdd$.pipe(
      bufferTime(0),
      filter((elements) => elements.length > 0),)
      .subscribe((elements) => {
        const withImages = elements
          .map(el => el.querySelector<HTMLImageElement>('img'))
          .filter(Boolean)
        const onImageReady = (count) => {
          if (count !== withImages.length) { return }
          this.layout(true);
        }

        if (withImages.length) {
          let imagesLoaded = 0
          withImages.map(img => img.src).forEach(src => {
            const image = new Image()
            image.onload = () => setTimeout(() => {
              onImageReady(++imagesLoaded)
            })
            image.onerror = () => setTimeout(() => {
              onImageReady(++imagesLoaded)
            })
            image.src = src
          })
        } else {
          this.layout(true);
        }
      });
  }

  ngOnDestroy() {
    if (this._msnry) {
      this._msnry.destroy();
    }
    if (this.elementsSubscriber) {
      this.elementsSubscriber.unsubscribe();
    }
  }

  public layout(reload = false) {
    if (this.isBrowser) {
      if (reload) {
        this._msnry.reloadItems();
      }
      this._msnry.layout();
    }
  }

  public add(element: HTMLElement) {
    if (!this.isBrowser) {
      return;
    }
    this.elementsToAddObserver.next(element);
  }

  public remove(element: HTMLElement) {
    if (!this.isBrowser) {
      return;
    }
    // Fix to remove objects that not in DOM
    try {
      this._msnry.remove(element);
    } catch (err) {
      // do nothing
    }
    this.layout();
  }
}
